<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
        <article @click.self="closeAllDetailView" :class="{ 'full-column' : !open && !relationOpen }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_okr_on.png" alt="">
                {{$t('viewName.okr')}}
            </h1>
            <span class="info-right">
              <select-drop-down v-on:set-selected-order="setSelectedOrder" :order="this.orderType"/>
            </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
        <!-- /ViewTitleBox -->
          <section class="animated fadeInRight flex-option">
            <div v-for="(obj, index) in getCurrentIncompletedObjectives" :key="obj.id" v-if="obj.key && obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
                <div @click="onClickObjective(obj.objective, obj.key, 'objectives')" class="ibox-title cursor">
                  <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? '' + obj.objective.progress : '0'" :setReadOnly="'false'" :objective="true" />
                  <div class="ibox-tools">
                    <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                      <button class="btn btn-secondary">
                        <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                        <span v-if="!getIsOpen(obj.key)">{{$t('indicateItemClose')}}</span>
                        <span v-else>{{$t('indicateAllNotice')}}</span>
                      </button>
                    </span>
                    <span class="info-right">
                      <span class="info-comment-detail" v-if="obj.objective.hasOwnProperty('sharedOwners') && Object.keys(obj.objective['sharedOwners']).length > 0">
                        <img :src="'static/img/assets/nav_people_on.png'">
                      </span>
                      <span class="info-comment-detail">
                        <span class="isExistUnread">
                          <!--
                           <img src="static/img/assets/comment.png" v-if="getOKRUnreadCommentKeys('objectives', obj.key) > 0">
                          -->
                          <img src="static/img/assets/comment.png">
                          <!--
                            <span v-if="getOKRUnreadCommentKeys('objectives', obj.key)">{{ getOKRUnreadCommentKeys('objectives', obj.key, getUserId) | lessThanHundred }}</span>
                          -->
                        </span>
                        <span v-bind:class="{ unread: isUnreadCommentsExist('objectives', obj.key, obj.objective.comments) }">{{getCommentsByCommentIdsTargetType(obj.objective.comments || {}, 'objectives').length}}</span>
                      </span>
                      <span class="info-comment-detail">
                        <!--
                         <img src="static/img/assets/relation_object_list_on.png" v-if="obj.objective.relations ? Object.keys(obj.objective.relations).length === 0 : true">
                        -->
                        <img src="static/img/assets/relation_object_list.png">
                        <span v-bind:class="{ unread: isUnreadOKRRelationExist(obj.objective, obj.key, 'objectives') }">{{ obj.objective.relations ? Object.keys(obj.objective.relations).length : 0 }}</span>
                      </span>
                      <div class="info-comment-right">
                        <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                        <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                      </div>
                        <okr-drop-down :tag="tag" :item="obj.objective" :id="obj.key"/>
                    </span>
                  </div>
                </div>
                  <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
                    <!-- ボックス -->
                    <!-- KeyResult1 -->
                    <div @click="onClickObjective(keyresult, key, 'keyresults')" v-for="(keyresult, key) in getTargetKeyresults(obj.key)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                      <div>
                        <span class="comp"></span>
                        <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? '' + keyresult.progress : '0'" :setReadOnly="'false'" :objective="false" />
                      </div>
                      <div class="ibox-tools">
                        <span class="info-menu"></span>
                        <span class="info-right">
                          <span class="info-comment-detail" v-if="keyresult.hasOwnProperty('sharedOwners') && Object.keys(keyresult['sharedOwners']).length > 0">
                            <img :src="'static/img/assets/nav_people_on.png'">
                          </span>
                          <span class="info-comment-detail">
                            <span class="isExistUnread">
                              <!-- <img v-if="isUnreadCommentsExist('keyresults', key, keyresult.comments)" src="static/img/assets/comment_on.png"> -->
                              <img src="static/img/assets/comment.png">
                              <!--
                                <span v-if="getOKRUnreadCommentKeys('keyresults', key, getUserId)">{{ getOKRUnreadCommentKeys('keyresults', key, getUserId) | lessThanHundred }}</span>
                              -->
                            </span>
                            <span v-bind:class="{ unread: isUnreadCommentsExist('keyresults', key, keyresult.comments) }">{{getCommentsByCommentIdsTargetType(keyresult.comments || {},'keyresults').length}}</span>
                          </span>
                          <span class="info-comment-detail">
                            <img src="static/img/assets/relation_object_list.png">
                            <!-- <img src="static/img/assets/relation_object_list_on.png" v-else> -->
                            <span v-bind:class="{ unread: isUnreadOKRRelationExist(keyresult, key, 'keyresults') }">{{ keyresult.relations ? Object.keys(keyresult.relations).length : 0 }}</span>
                          </span>
                          <div class="info-comment-right">
                            <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{keyresult.startDate}}</span>
                            <span class="info-comment-detail date-color block-display">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                          </div>
                          <okr-drop-down v-if="!getIsComp(keyresult)" :tag="'progressKey'" :item="keyresult" :id="key"/>
                          <okr-drop-down v-else :tag="'compKey'" :item="keyresult" :id="key"/>
                        </span>
                      </div>
                    </div>
                    <!-- /KeyResult1  -->
                    <div class="ibox-child cursor text-center add-key" style="padding-left:0;">
                        <div id="add-key1" class="panel-footer info-add">
                            <router-link :to="{ name: 'KeyresultRegist', params: { parentObjId: obj.key } }" class="btn btn-success"><i class="fa fa-plus"></i>{{$t('addKeyResultStr')}}</router-link>
                        </div>
                    </div>
                  <!-- /ボックス -->
                </div>
            </div>
        </section>
      </div>
    </article>
    <okr-detail-view :targetItemKey="targetItemKey" :targetType="targetType" ref="okrDetailView" @close-detail-view="onClickCloseDetailView" @open-add-relation="onClickAddRelation"/>
    <okr-add-relation-detail-view :targetItemKey="targetItemKey" :targetType="targetType" ref="okrAddRelationDetailView" @close-detail-view="onClickCloseAddRelationDetailView" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Objective from '@/components/Okr/Objective'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import RelationItem from '@/components/Okr/RelationItem'
import OkrDetailView from '@/components/DetailView/OkrDetailView'
import OkrAddRelationDetailView from '@/components/DetailView/OkrAddRelationDetailView'
import CommonJs from '@/js/common'
import moment from 'moment'
import drag from '@branu-jp/v-drag'
import { liteMode } from '@/main.js'
// import Tutorial from '@/components/Tutorial'

export default {
  name: 'OkrList',
  mixins: [CommonJs],
  components: {
    Objective,
    SelectDropDown,
    OkrDropDown,
    RelationItem,
    OkrDetailView,
    OkrAddRelationDetailView
  },
  directives: {
    drag
  },
  data: function () {
    return {
      isLiteMode: liteMode,
      tag: 'progress',
      tutorialShow: false,
      objectives: [],
      targetType: 'objectives',
      objectiveCount: 30,
      relationCount: 10,
      keyresultOpen: {},
      open: false,
      relationOpen: false,
      targetItemKey: '',
      isShowCommentForm: true
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OkrList'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('okrs/', [
      'getIsReadRelation'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByParentObjId',
      'getCurrentKeyresults'
    ]),
    ...mapGetters('objectives/', [
      'getCurrentObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment',
      'getCommentsByCommentIdsTargetType'
    ]),
    getCurrentIncompletedObjectives: function () {
      if (this.getCurrentObjectives) {
        let incompletedObjectives = []
        const currentObjectives = this.getCurrentObjectives
        for (let key in currentObjectives) {
          if (key === '.key') { continue }
          if (currentObjectives[key] && currentObjectives[key].contentText !== '') {
            if (!currentObjectives[key].isComplete) {
              incompletedObjectives.push({key: key, objective: currentObjectives[key]})
            } else if (currentObjectives[key].isComplete === false) {
              incompletedObjectives.push({key: key, objective: currentObjectives[key]})
            } else {
              continue
            }
          }
        }
        if (this.orderType.key === '') {
          return incompletedObjectives.slice(0, this.objectiveCount)
        } else {
          const orderType = this.orderType
          incompletedObjectives.sort(function (a, b) {
            console.log('orderType.key:::', orderType.targetKey)
            if (!a.objective[orderType.targetKey] && !b.objective[orderType.targetKey]) {
              return 0
            } else if (!a.objective[orderType.targetKey]) {
              return -1
            } else if (!b.objective[orderType.targetKey]) {
              return 1
            } else {
              return a.objective[orderType.targetKey] - b.objective[orderType.targetKey]
            }
          })
          if (orderType.isDesc) {
            return incompletedObjectives.reverse().slice(0, this.objectiveCount)
          } else {
            return incompletedObjectives.slice(0, this.objectiveCount)
          }
        }
      } else {
        return []
      }
    },
    orderType () {
      let ret
      switch ((this.getCurrentUserInfo || {}).okrOrder) {
        case 'updated_desc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: true
          }
          break
        case 'updated_asc':
          ret = {
            targetKey: 'modifiedAt',
            isDesc: false
          }
          break
        case 'created_asc':
          ret = {
            targetKey: 'createdAt',
            isDesc: false
          }
          break
        case 'created_desc':
        default:
          ret = {
            targetKey: 'createdAt',
            isDesc: true
          }
          break
      }
      return ret
    }
  },
  methods: {
    ...mapActions({
      removeTutorialFlag: 'removeTutorialFlag',
      setReadTime: 'setReadTime'
    }),
    ...mapActions('okrs/', {
      setProgress: 'SET_ITEM_PROGRESS',
      addRelation: 'ADD_RELATION'
    }),
    ...mapActions('keyResults/', {
      setNewKeyresult: 'SET_NEW_KEYRESULT'
    }),
    ...mapActions('comments/', {
      sendNewComment: 'SEND_NEW_COMMENT'
    }),
    ...mapActions('objectives/', {
      setNewObjective: 'SET_NEW_OBJECTIVE'
    }),
    ...mapActions('users/', {
      setOkrOrderType: 'SET_OKR_ORDER_TYPE'
    }),
    endTutorial: function () {
      this.tutorialShow = false
      this.removeTutorialFlag()
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.objectiveCount - 1) {
        this.objectiveCount += 30
      }
    },
    relationsVisibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.relationCount - 1) {
        this.relationCount += 10
      }
    },
    isUnreadCommentsExist (itemType, itemId, commentIds) {
      for (let commentId in commentIds) {
        if (!this.getIsReadComment(itemType, this.getUserId, itemId, commentId)) {
          return true
        }
      }
      return false
    },
    isUnreadOKRRelationExist (obj, key, itemType) {
      for (let relationKey in obj.relations) {
        if (!this.getIsReadRelation(itemType, this.getUserId, key, relationKey)) {
          return true
        }
      }
      return false
    },
    onClickObjective: function (obj, key, type) {
      console.log('keyresult', obj)
      if (this.relationOpen) this.relationOpen = false
      this.targetItemKey = key
      this.targetType = type
      if (!this.open) {
        this.open = true
      }
      if (this.$refs.okrDetailView) {
        this.$refs.okrDetailView.openDetailView()
        this.$refs.okrAddRelationDetailView.relationOpen = false
      }
      // this.$ref.checkTransition()
      if (!this.isShowCommentForm) {
        for (let relationKey in obj.relations) {
          if (!this.getIsReadRelation(type, this.getUserId, key, relationKey)) {
            this.setReadTime({
              itemType: 'relations',
              targetType: type,
              targetOwner: this.getUserId,
              targetId: key,
              relationKey: relationKey,
              readTime: new Date().getTime()
            })
          }
        }
      } else {
        for (let commentId in obj.comments) {
          if (!this.getIsReadComment(type, this.getUserId, key, commentId)) {
            this.setReadTime({
              itemType: 'comments',
              targetType: type,
              targetOwner: this.getUserId,
              targetId: key,
              itemId: commentId,
              readTime: new Date().getTime()
            })
          }
        }
      }
    },
    onClickAddRelation: function () {
      this.open = false
      this.$refs.okrDetailView.closeDetailView()
      this.$nextTick(() => {
        this.relationOpen = true
        this.$refs.okrAddRelationDetailView.openDetailView()
      })
      console.log('AddRelation open !')
    },
    onClickCancel: function () {
      this.showModal = false
      // this.open = true
    },
    setSelectedOrder: function (value) {
      if (value.targetKey === 'createdAt') {
        if (value.isDesc) {
          this.setOkrOrderType('created_desc')
        } else {
          this.setOkrOrderType('created_asc')
        }
      } else
      if (value.targetKey === 'modifiedAt') {
        if (value.isDesc) {
          this.setOkrOrderType('updated_desc')
        } else {
          this.setOkrOrderType('updated_asc')
        }
      }
      this.objectiveCount = 30
    },
    getTargetKeyresults (key) {
      return this.getKeyresultsByParentObjId(key)
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    onClickCloseDetailView () {
      this.open = false
    },
    closeAllDetailView () {
      this.$refs.okrDetailView.closeDetailView()
      this.$refs.okrAddRelationDetailView.closeDetailView()
      this.open = false
      this.relationOpen = false
    },
    setRelationKeyresultOpen: function (objectiveId) {
      Vue.set(this.modalKeyresultOpen, objectiveId, Object.keys(this.modalKeyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.modalKeyresultOpen[objectiveId])
    },
    getRelationIsOpen: function (objectiveId) {
      return Object.keys(this.modalKeyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.modalKeyresultOpen[objectiveId]
    },
    getDetail: function (value) {
      console.log('objective value', value)
      let userId = value.userId
      console.log(userId)
      let itemId = {}
      itemId[value.type] = value.itemId
      this.$router.push({ name: 'User', params: { userId: value.userId, item: itemId } })
      console.log('push success')
    },
    onClickCloseAddRelationDetailView () {
      this.relationOpen = false
      this.open = true
      this.$refs.okrDetailView.openDetailView()
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    lessThanHundred: function (unreadCount) {
      return unreadCount > 99 ? 99 : unreadCount
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  .modal-wrapper{
    height: 100vh;
    display: table-cell;
    vertical-align: middle;
  }
  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .swal2-container {
    z-index: 100000;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .modal-enter-active, .modal-leave-active {
    transition: all .2s ease ;
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;
  }
  /* .sub-active {
    width: 100%;
  } */
  /* .ibox-child:last-of-type {
    border-top: solid 1px #e7eaec;
    border-top: 0px;
  } */
  /* .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
    border-top: 0px;
  } */
  /* .detail-head {
    height: 20vh;
    transition: 0.2s all ease-in-out;
  }
  .detail-open {
    position: absolute;
    bottom: 0;
    left: 45%;
    display: block;
    margin: 0 auto 0.5em;
  }
  .detail-active {
    height: 50vh;
  } */
</style>



// WEBPACK FOOTER //
// src/views/okr/OkrList.vue